import { useState } from 'react';

export default function FAQSection() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(0);

  const faqs = [
    {
      question: '¿Cuándo puedo registrarme?',
      answer: 'El registro está acotado a unas fechas. En la edición del 2026, podrás completarlo desde las 12:00h del 18-11-2025 hasta las 23:59h del 30-11-2025'
    },
    {
      question: '¿Cuántos accesos puedo solicitar?',
      answer: 'Podrás solicitar desde 1 a 5 accesos por cuenta de correo electrónico. Por lo tanto, puedes registrarte más de una vez si tienes más de un correo electrónico.'
    },
    {
      question: '¿Qué debo hacer cuando me he registrado?',
      answer: 'Esperar. El sorteo se celebrará el día 2 de diciembre de 2024 debiéndose completar el donativo hasta el día 15 de diciembre de 2024.'
    },
    {
      question: '¿Es importante el orden de registro para el sorteo?',
      answer: 'No, rotundamente no. Podrás completar el registro el primer día de inicio o el último. Las posibilidades de obtener los accesos son las mismas pues el sorteo se realiza de forma aleatoria entre los participantes.'
    },
    {
      question: '¿Qué se tiene en cuenta a la hora de realizar el sorteo?',
      answer: 'A la hora de realizar el sorteo se tiene en cuenta el horario seleccionado en el registro y el medio de transporte a utilizar. Son los dos criterios que se toman en cuenta junto con el número de accesos que la organización pone a disposición para dicha franja horaria y dicho medio de transporte.'
    },
    {
      question: '¿Cómo accedo al evento?',
      answer: 'Para acceder al evento deberás aportar los códigos QR que la organización pondrá a tu disposición. Siempre disponibles en la APP oficial. Si has sido ganador pero no has completado el proceso, no podrás acceder al evento. Con los códigos QR la organización validará el uso del transporte y el acceso. Sólo se hará una validación de transporte y una de acceso.'
    },
    {
      question: '¿Desde qué edad se necesita obtener el acceso?',
      answer: 'Se trata de un evento totalmente solidario, por lo que todos los asistentes de cualquier edad deberán contar con un acceso para poder ser partícipes del evento.'
    },
    {
      question: '¿Como puedo averiguar los itinerarios de acceso al evento?',
      answer: 'Puedes visitar el mapa que pone a disposición del público Protección civil en el enlace proporcionado en la aplicación oficial.'
    },
    {
      question: '¿El horario que indica el acceso corresponde al momento de entrada al recinto?',
      answer: 'Efectivamente, ese horario es el aproximado de entrada al Campamento Real, pero hay que recordar que sobre todo en las horas centrales del evento se acumulan retrasos.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Preguntas frecuentes</h1>
          <p className="text-lg text-gray-600 mb-4">
            Tranquil@, hemos pensado en todo. Sabemos que os rondan ciertas dudas y nuestro propósito es aclararlas.
          </p>
          <p className="text-lg text-gray-600">
            Para más información tenéis disponible el email de contacto{' '}
            <a href="mailto:info@campamentoreal.app" className="text-red-600 hover:text-red-700 font-medium">
              info@campamentoreal.app
            </a>
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors duration-200"
                >
                  <span className="font-medium text-gray-900">{faq.question}</span>
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`ri-${openFAQ === index ? 'subtract' : 'add'}-line text-xl text-red-600`}></i>
                  </div>
                </button>
                {openFAQ === index && (
                  <div className="px-6 pb-4">
                    <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
